
import Vue from 'vue'
import App from './App'
import router from './router'
import api from './common/constants';
import http from './common/http';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueCookies from 'vue-cookies'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.use(VueCookies)
Vue.use(Viewer)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$http = http;
Vue.prototype.$api = api;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js